module.exports = __webpack_public_path__ + "img/list.7a5322a9.svg";